import { ILabRequisitionData } from "@home-health-notify/domain";
import LabOrderListItem from "./LabOrderListItem";
import {
  OrdersContainer,
  OrdersHeader,
  NoOrdersText,
  OrdersList,
} from "./LabOrders.style";
import { useTranslation } from "react-i18next";

type LabOrdersProps = {
  requisition: ILabRequisitionData;
};

const LabOrders = ({ requisition }: LabOrdersProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "labRequisition" });

  if (!requisition.orders || requisition.orders.length === 0) {
    return (
      <OrdersContainer>
        <OrdersHeader>{tNs("orderDetails")}</OrdersHeader>
        <NoOrdersText>{tNs("noOrderDetailsAvailable")}</NoOrdersText>
      </OrdersContainer>
    );
  }

  return (
    <OrdersContainer>
      <OrdersHeader>{tNs("orderDetails")}</OrdersHeader>
      <OrdersList>
        {requisition.orders.map(order => (
          <LabOrderListItem key={order.id} order={order} />
        ))}
      </OrdersList>
    </OrdersContainer>
  );
};

export default LabOrders;
